import {environment} from "../../environments/environment";

export class Config {

  public static serviceKey: string = 'gTcjslfqqBFFwJKBnFgQYhkQEJpplLaDKfj';
  public static googleClientId: string = '179822974689-jb6vtspghjmmibq6eq930dq7j3la3s9h.apps.googleusercontent.com';
  public static managerPluginSlug: string = '10web-manager';
  public static aiAssistantPluginSlug: string = 'ai-assistant-by-10web';
  public static yoastAddonSlug: string = 'ai-assistant-by-10web-seo-pack';
  public static backupPluginSlug: string = 'backup-wd';
  public static performanceSlug: string = 'performance';
  public static imageOptimizerPluginSlug: string = 'image-optimizer-wd';
  public static optimizerPluginSlug: string = 'tenweb-speed-optimizer';
  public static seoPluginSlug: string = 'seo-by-10web';
  public static builderPluginSlug: string = 'tenweb-builder';
  public static tenWebThemeSlug: string = 'tenweb-website-builder-theme';
  public static wpThemesSlugs: string[] = [Config.tenWebThemeSlug, 'twentysixteen', 'twentyseventeen', 'twenty8teen', 'twentynineteen', 'twentytwenty', 'twentytwentyone', 'twentytwentytwo', 'twentytwentythree'];
  public static tenWebProducts: string[] = [Config.tenWebThemeSlug, Config.managerPluginSlug, Config.builderPluginSlug];
  public static elementorPluginSlug: string = 'elementor';
  public static woocommercePaymentsPluginSlug: string = 'woocommerce-payments';
  public static woocommerceTaxPluginSlug: string = 'woocommerce-services';
  public static woocommercePluginSlug: string = 'woocommerce';
  public static securityPluginSlug: string = '10web-security';
  public static servicePluginSlugs: string[] = [Config.performanceSlug, Config.imageOptimizerPluginSlug, Config.backupPluginSlug, Config.seoPluginSlug, Config.securityPluginSlug, Config.managerPluginSlug, Config.tenWebThemeSlug];
  public static wpAdminRedirectorUrl: string = 'wp-admin-redirector.html';

  public static vibeCodingEndpoint: string = environment.vibeCodingEndpoint;
  public static authEndpoint: string = environment.authEndpoint;
  public static wvcAcceptToken: string = environment.wvcAcceptToken;
  public static coreEndpoint: string = environment.coreEndpoint;
  public static managerEndpoint: string = environment.managerEndpoint;
  public static backupEndpoint: string = environment.backupEndpoint;
  public static optimizerEndpoint: string = environment.optimizerEndpoint;
  public static seoEndpoint: string = environment.seoEndpoint;
  public static performanceEndpoint: string = environment.performanceEndpoint;
  public static optimizerDemonstrationEndpoint: string = environment.optimizerDemonstrationEndpoint;
  public static securityEndpoint: string = environment.securityEndpoint;
  public static notificationsEndpoint: string = environment.notificationsEndpoint;
  public static notificationsSocketEndpoint: string = environment.notificationsSocketEndpoint;
  public static wordpressEndpoint: string = 'https://api.wordpress.org/';
  public static googleEndpoint: string = 'https://www.googleapis.com/';
  public static publicEndpoint: string = environment.publicEndpoint;
  public static miniProductsEndpoint: string = environment.miniProductsEndpoint;
  public static miniToolsEndpoint: string = environment.miniToolsEndpoint;
  public static lxdEndpoint: string = environment.lxdEndpoint;
  public static typeFormEndpoint: string = environment.typeFormEndpoint;
  public static aiAssistantEndpoint: string = environment.aiAssistantEndpoint;
  public static aiBuilderEndpoint: string = environment.aiBuilderEndpoint;
  public static woocomEndpoint: string = environment.woocomEndpoint;
  public static tenWebWoocomEndpoint: string = environment.tenWebWoocomEndpoint;
  public static tenWebStripeEndpoint: string = environment.tenWebStripeEndpoint;
  public static woocomPaymentsEndpoint: string = environment.woocomPaymentsEndpoint;
  public static woocomAnalyticsEndPoint: string = environment.woocomAnalyticsEndpoint;
  public static expertsUrl: string = environment.expertsUrl;
  public static dashUrl: string = environment.dashUrl;
  public static demoUrls: string[] = environment.demoUrls;
  public static featuredPlugins: string[] = ['wp-live-chat-software-for-wordpress', 'meta-box'];
  public static wvcThemeSlug: string = 'wvc-theme';

  public static firebaseConfig: Object = environment.firebaseConfig;
  public static firebasePublicConfig: Object = environment.firebasePublicConfig;
  public static discountFifty: string = 'RETURN50';
  public static couponsList: string[] = ['1wf', 'blk-30', 'EXPLORE10', 'BUILD15', 'DREAM20', 'TRIAL10', 'POWER15', 'JOURNEY20', 'PRO10', 'PRO15', 'PRO20', 'PRO50', 'geoPersonalLT23', 'geoPersonal23', 'geoPremium23', 'geoPremiumLT23', 'geoAgency23', 'geoAgencyLT23', 'ecPersonal23', 'ecPersonalLT23', 'ecPremium23', 'ecPremiumLT23', 'agencyPersonal23', 'agencyPersonalLT23', 'agencyPremium23', 'agencyPremiumLT23', 'monthlyLT23', 'monthlyFY23', 'HubSpot60', 'BLK50OFF', 'BUILDER2', 'ECOMAGENTS', 'ECOMAGENTS40', 'AISIMPLIFIED'];
  public static popupCouponPrefixForAutoApply: string = 'campaign-';
  public static couponPrefixForExtend: string = 'campaign-exd-';
  public static couponPrefixForExtendWithCoupon: string = 'campaign-exd-cpn-';
  public static couponPrefixForExtendWithCouponDowngrade: string = 'campaign-exd-cpn-dwn-to';
  public static prefixForDowngradeToTrial: string = 'dwn-to-trial';
  public static prefixForDowngradeToBase: string = 'dwn-to-base';

  public static paypalLocalKeys: string[] = ['switchPlanAnnual', 'dbFromAdditional', 'dbFromPeriodCycleChange',
    'dbFrom1MFPopupPaypal', 'dbFromBoosterPopupPaypal', 'dbFromAdditionalCdn'];

  public static ignoredActivities: string[] = [
    'client_logout_except_current_session',
    'client_logout',
    'generate_website_screenshot',
    'staging_website_create',
    'create_website',
    'page_speed_score',
    'demo_optimizer_check_score',
    'stripe_account_created'
  ];

  public static ignoredOngoingActivities: string[] = [
    'client_logout_except_current_session',
    'client_logout',
    'custom_page_is_optimizing',
    /*'first_page_is_optimizing',*/
    'generate_website_screenshot',
    'add_website',
    'upgrade_plan',
    'ai_create_website',
    'page_speed_score',
    'demo_optimizer_check_score',
  ];

  public static publishedSinglePluginPlans: string[] = [
    'photo-gallery',
    'form-maker',
    'event-calendar-wd',
    'slider-wd',
    'wd-google-maps',
    'ecommerce-wd',
    'wd-mailchimp',
    'wd-facebook-feed',
    'wd-instagram-feed',
    'wd-youtube',
    'wd-google-analytics',
    'post-slider-wd',
    'ad-manager-wd',
    'faq-wd',
    'spider-event-calendar',
    'staff-team'
  ];

  public static sentryToken: 'https://8098d9b49afc42f89ec1b7836381602c@o397950.ingest.sentry.io/5253670';

  public static stripeKey: string = environment.stripeKey;

  public static googleInsightsKey: string = environment.googleInsightsKey;


  public static googleRecaptcha: string = environment.googleRecaptcha;

  public static malihuScrollbarDefaultOptions: any = {
    theme: 'minimal-dark',
    autoHideScrollbar: true,
    scrollInertia: 250,
    snapOffset: 100
  };

  public static diffPreviewExtensions: string[] = [
    'html',
    'php',
    'js',
    'ts',
    'json',
    'css',
    'sass',
    'scss',
    'less',
    'sql',
    'txt',
    'md'
  ];

  public static hostname = environment.hostname;

  public static hostnameList = ['.10web.club', '.10web.site', '.10web.cloud', '.10web.me'];

  public static typeFormUrl = 'https://3oq3fq73sz5.typeform.com/to/';
  public static typeFormOnboardingId = 'kQ8Bn0gn';
  public static typeFormSlackId = 'mwfkURRf';
  public static typeFormSlackIdSorry = 'jVLzYADs';
  public static typeFormSlackIdHappy = 'ymUd1Hni';
  public static typeFormExpertId = 'CpwoRU6m';
  public static typeFormToken = 'Bearer GPU7ATu3hD5dqSnnXa3wtBqHNHLuV5rYCYuKtELA3JZ4';
  public static apiResellerPlanId = environment.apiResellerPlanId;
  public static defaultStarterPlanId = environment.defaultStarterPlanId;
  public static speedStarterPlanId = environment.speedStartedPlanId;
  public static basePlanId = environment.basePlanId;
  public static boosterBetaPlanId = environment.boosterBetaPlanId;
  public static photoGalleryPluginIds = environment.photoGalleryPluginIds;
  public static aiBuilderPluginIds = environment.aiBuilderPluginIds;
  public static aiAssistantPluginId = environment.aiAssistantPluginId;
  public static aiCreateWebsitePluginId = environment.aiCreateWebsitePluginId;
  public static demoAiPluginId = environment.demoAiPluginId;
  public static managerPluginId = environment.managerPluginId;
  public static installBlankPluginId = environment.installBlankPluginId;
  public static builder2PluginId = environment.builder2PluginId;
  public static builder2HostedPluginId = environment.builder2HostedPluginId;
  public static vibeCodingPluginId = environment.vibeCodingPluginId;
  public static availableSubscriptionId = environment.availableSubscriptionId;
  public static boosterAutoConnectVersion = 'https://10web-products-production.s3.us-west-2.amazonaws.com/tenweb-speed-optimizer/tenweb-speed-optimizer/2.0.9-connect/tenweb-speed-optimizer.zip';
  public static demoDomainId: number = environment.demoDomainId;
  public static imageOptimizerPluginId: number = environment.imageOptimizerPluginId;
  public static demoWorkspaceId: number = environment.demoWorkspaceId;
  public static demoWebsiteUrl: string = environment.demoWebsiteUrl;
  public static smoochIntegrationId: string = environment.smoochIntegrationId;
  public static suiteDev: number = environment.suiteDevRoleId;
  public static smoochTestIntegrationId: string = '659bda10370bbb7ba92da6da';
  public static countryList = ['GB', 'CA', 'FR', 'DE', 'IT', 'ES', 'NL', 'AU', 'AE', 'MX', 'PT', 'IL', 'CH',
    'BE', 'SE', 'SG', 'AT', 'DK', 'FI', 'NO', 'NZ', 'TH', 'IE', 'CY', 'GR', 'LV', 'EE', 'LT'];
  public static englishCountries = ['US'];
  public static tier1Countries = [
    'US', // United States
    'GB', // United Kingdom
    'FR', // France
    'DE', // Germany
    'IT', // Italy
    'CA', // Canada
    'ES', // Spain
    'NL', // Netherlands
    'AU', // Australia
    'AE', // United Arab Emirates
    'MX', // Mexico
    'PT', // Portugal
    'IL', // Israel
    'CH', // Switzerland
    'BE', // Belgium
    'SE', // Sweden
    'SG', // Singapore
    'AT', // Austria
    'DK', // Denmark
    'FI', // Finland
    'NO', // Norway
    'NZ', // New Zealand
    'TH', // Thailand
    'IE', // Ireland
    'CY', // Cyprus
    'GR', // Greece
    'LV', // Latvia
    'EE', // Estonia
    'LT'  // Lithuania
  ];
  public static twCareLink: string = 'https://help.10web.io/hc/en-us/requests/new';
  public static firstPaymentOfferCoupon = '1wf_50percent_discount';
  public static _1wfCoupon = '1wf';
  public static aiStarterAnnual = environment.aiStarterAnnual;

  public static business:  any = {
   personal: {
     lifeTime: 'geoPersonalLT23',
     firstPayment: 'geoPersonal23',
   },
    premium: {
      lifeTime: 'geoPremiumLT23',
      firstPayment: 'geoPremium23',
    },
    enterprise: {
     lifeTime: 'geoAgencyLT23',
     firstPayment: 'geoAgency23',
   }
  };

  public static ecommerce:  any = {
   personal: {
     lifeTime: 'ecPersonalLT23',
     firstPayment: 'ecPersonal23',
   },
    premium: {
      lifeTime: 'ecPremiumLT23',
      firstPayment: 'ecPremium23',
    }
  };

  public static agency:  any = {
   personal: {
     lifeTime: 'agencyPersonalLT23',
     firstPayment: 'agencyPersonal23',
   },
    premium: {
      lifeTime: 'agencyPremiumLT23',
      firstPayment: 'agencyPremium23',
    }
  };

  public static stripeConnectKey: string = 'pk_test_51O9OFOD2fAmjePnCJaW4e2rnM7IB9Z9abQOASa8u017URP9nYxeU6RoYykHK5GtSGqHJGZawEwQeywyLY8TLu1Vn00VzgbnLzJ';
  public static onboardingFeedbackTestId: string = 'c675935c-e963-4a43-b7fa-83a5e30cdfa9';
  public static accept: string = environment.accept;
  public static paypalIsProduction: boolean = environment.paypalIsProduction;

  public static includedPaymentIds = [
    "woocommerce_payments",
    "bacs",
    "cheque",
    "cod",
    "tenweb_payments_stripe"
  ];

    public static getCookie(name) {
        const cookies = document.cookie.split("; ");
        for (let c of cookies) {
            const [key, val] = c.split("=");
            if (key === name) return val;
        }
        return null;
    }
}
